import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { User, UserService, UsersStore } from '@fry/lib/users';
import { FormData } from '@fry/lib/forms';
import { UserAddForm } from './user-add.form';
import { Observable } from 'rxjs';
import { NotifyService } from '@fry/lib/utils';


@Component({
    selector: 'app-user-add',
    templateUrl: './user-add.component.html',
    providers: [
        UserAddForm,
        UserService
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UserAddComponent implements OnInit {

  public user: User;
  public formData$: Observable<FormData>;

  constructor(
    private users: UsersStore,
    private addForm: UserAddForm,
    private notify: NotifyService,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.user = this.users.blank();
    this.formData$ = this.addForm.init(this.user);
  }


  onSubmit() {
    this.addForm.submit(this.user).subscribe(
      (user) => {
        this.user = user;
        this.notify.success($localize `Profile successfully saved`);
        this.router.navigate(['..', this.user.doc.username, 'dashboard'], { relativeTo: this.route });
      },
      error => {
        this.notify.error(error);
      }
    );
  }

}
